// simple-layout.component.ts
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-simple-layout',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, RouterOutlet, SidebarComponent],
  template: `
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <main class="p-4">
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
  `,
})
export class SimpleLayoutComponent {}
